export default __webpack_public_path__ + "../staticImages/sprite-proclima-2x.png";